<template>
	<h3 class="title">{{ isSelectMode ? title.select : title.regist }}</h3>
	<perfect-scrollbar
		v-if="isSelectMode"
		class="asset_list_wrap"
		:options="{ wheelPropagation: false }"
	>
		<div class="mh_50v">
			<ul class="d_flex merchant_list">
				<li v-for="item in merchantList" :key="item.seq">
					<a @click="selectMerchant(item)">
						<div class="card">
							<p class="shop_name" :title="item.merchant_name">
								{{ item.merchant_name }}
							</p>
							<p class="date">
								{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}
							</p>
							<p class="shop_id mt_15">{{ item.merchant_id }}</p>
						</div>
					</a>
				</li>
				<li>
					<a @click="isSelectMode = false">
						<div class="card border_dashed">
							<span class="icon_add"></span>
						</div>
					</a>
				</li>
			</ul>
		</div>
	</perfect-scrollbar>
	<div v-else>
		<div class="mb_20 tal">
			<p class="mb_10">{{ $t('merchant.picker.merchant_name') }}</p>
			<div>
				<input type="text" v-model="merchantName" />
			</div>
		</div>
		<div class="mb_30 tal">
			<p class="mb_10">{{ $t('merchant.picker.merchant_id') }}</p>
			<div>
				<input type="text" v-model="merchantId" />
			</div>
		</div>
		<div class="button_area">
			<button @click="isSelectMode = true">{{ $t('button.back') }}</button>
			<button @click="createMerchant" class="fc_red">
				{{ $t('button.register') }}
			</button>
		</div>
	</div>
	<ModalMessage v-if="successModal" @closeModal="successModal = false">
		<div class="status_icon success"></div>
		<p class="status_text">{{ $t('merchant.picker.success_shop_register') }}</p>
		<div class="button_area">
			<button
				class="fc_red oneBtn"
				@click="(successModal = false), (isSelectMode = true)"
			>
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import ModalMessage from '@/components/Layout/ModalMessage';
import { createMerchant, fetchMerchantList } from '@/api/pg';
import { commonError } from '@/common/dialog';

export default {
	name: 'MerchantPicker',
	emits: ['selectMerchant', 'closeModal'],
	components: { ModalMessage },
	data() {
		return {
			merchantList: [],
			isSelectMode: true,
			title: {
				select: this.$t('merchant.picker.title1'),
				regist: this.$t('merchant.picker.title2'),
			},
			merchantName: '',
			merchantId: '',
			successModal: false,
		};
	},
	watch: {
		isSelectMode(val) {
			if (val) {
				this.merchantName = '';
				this.merchantId = '';
			}
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadMerchantList();
		},
		async loadMerchantList() {
			const { data } = await fetchMerchantList({ no_paging: 1 }).catch(
				commonError,
			);
			this.merchantList = data;
		},
		selectMerchant(merchantInfo) {
			// this.$router.push({
			// 	name: 'merchant-console-catalog',
			// 	params: { merchant_seq: merchantSeq },
			// });
			// this.$emit('closeModal');
			const obj = {
				name: 'merchant-console-catalog',
				params: {
					merchant_seq: merchantInfo.seq,
					merchant_name: merchantInfo.merchant_name,
					merchant_id: merchantInfo.merchant_id,
				},
			};
			this.$emit('selectMerchant', obj);
			this.$emit('closeModal');
		},
		async createMerchant() {
			if (!this.validations()) return;
			const params = {
				merchant_name: this.merchantName,
				merchant_id: this.merchantId,
			};
			await createMerchant(params)
				.then(() => {
					this.successModal = true;
					// 임시
					alert(this.$t('merchant.picker.success_shop_register'));
					this.isSelectMode = true;
					this.loadMerchantList();
				})
				.catch(commonError);
		},
		validations() {
			if (!this.merchantName) {
				alert(this.$t('merchant.picker.insert_shop_name'));
				return false;
			}
			if (!this.merchantId) {
				alert(this.$t('merchant.picker.insert_shop_id'));
				return false;
			}
			return true;
		},
	},
};
</script>
<style scoped>
h3.title {
	position: absolute;
	top: 20px;
}
</style>
